import styled from "styled-components";

export const Box = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 25px;
  padding: 0 1px;
  /*overflow-y: scroll;
  overflow-x: hidden;
  height: 65dvh;*/
  h5 {
    font-size: 18px;
    font-weight: bold;
    color: #343536;
  }
`;

export const BoxDescription = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  h5 {
    font-size: 18px;
    font-weight: bold;
    color: #343536;
  }
`;

export const BoxButtons = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: start;
  margin-top: 15px;
  gap: 20px;
`;

export const BtnFixed = styled.div`
  //position: fixed;
  //bottom: 15px;
  //width: 93%;

  display: flex;
  flex-direction: row;
  gap: 25px;
  padding-bottom: 15px;
`;
export const AriaBox = styled.div`
  background-color: white;
  display: grid;
  grid-template-columns: 1fr 1fr;
  padding: 20px 10px;
  gap: 10px;

  label {
    padding: 5px 8px;
    background-color: #f7f8fa;
    margin-left: 10px;
  }
`;

// Estilos para seção de Condições Neurológicas
export const NeurologicalSection = styled.div`
  background: linear-gradient(135deg, #fff8e1 0%, #fff3e0 100%);
  border: 2px solid #ffb74d;
  border-radius: 12px;
  padding: 20px;
  margin: 20px 0;
  box-shadow: 0 2px 8px rgba(255, 152, 0, 0.15);
`;

export const NeurologicalHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 15px;

  h5 {
    font-size: 18px;
    font-weight: bold;
    color: #e65100;
    margin: 0;
  }
`;

export const NeurologicalGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 8px;
  max-height: 300px;
  overflow-y: auto;
  padding: 10px;
  background-color: rgba(255, 255, 255, 0.7);
  border-radius: 8px;
  border: 1px solid #ffe0b2;

  label {
    padding: 8px 12px;
    background-color: white;
    border-radius: 6px;
    margin: 0;
    transition: all 0.2s ease;
    border: 1px solid #e0e0e0;

    &:hover {
      background-color: #fff8e1;
      border-color: #ffb74d;
    }
  }

  @media (min-width: 600px) {
    grid-template-columns: 1fr 1fr;
  }
`;
